import { useState, useEffect, useContext, useCallback } from 'react';
import { showErrorToast } from '../../../components/Toast/Toaster';
import { useConfigStore } from "../../../store/ConfigMgt/ConfigStore";
import { useCodAutomationStore } from '../../../store/CodAutomation/codAutomationStore';
import { UserContext } from '../../../helper/ProtectedRoute';
import { Modal } from 'react-bootstrap';
import { PaginationMainTable } from '../../../components/Tables/PaginationMainTable';
import BankChargesTableComponent from '../Tables/BankCharges';
import BankChargesForm from './BankChargesForm';
import { Button } from '../../../components/UI/button';
import { Plus, RefreshCw } from 'lucide-react';
import '../../../styles/tailwind.css';
import '../../../styles/tailwind-shadcn-fixes.css';
import { useAbortableLoad } from '../../../components/UI/loading';

const BankCharges = ({ setTab }) => {
  const [openAddModal, setOpenAddModal] = useState(false);
  // List request: skeleton, Cancel and latest-wins ordering. The service
  // takes no AbortSignal, so Cancel drops the response.
  const listLoad = useAbortableLoad();
  const isLoadingPage = listLoad.loading;
  const [role, setRole] = useState(sessionStorage.getItem('user_access_role'));

  const [state] = useContext(UserContext);

  const filterCountries = useConfigStore((state) => state?.filterCountries);
  const filterCurrency = useConfigStore((state) => state?.filterCurrency);
  const getAllBankCharges = useCodAutomationStore((state) => state?.getAllBankCharges);
  const countriesData = useConfigStore((state) => state?.countriesData);
  const currencyData = useConfigStore((state) => state?.currencyData);
  const bankChargesList = useCodAutomationStore((state) => state?.bankChargesList);

  useEffect(() => {
    setRole(state.roles);
  }, [state.roles]);

  const getData = useCallback(async () => {
    try {
      await listLoad.track(() => getAllBankCharges());
    } catch (error) {
      showErrorToast('Error');
    } finally {
    }
  }, [getAllBankCharges]);

  useEffect(() => {
    getData();
  }, [getData]);

  useEffect(() => {
    let paramslink = `?page=${0}&size=${300}`;
    if (
      countriesData?.data?.data?.content?.length === undefined ||
      countriesData?.data?.data?.content?.length < 1
    ) {
      filterCountries(paramslink);
    }
    let param = `?page=${0}&size=${500}`;
    if (
      currencyData?.data?.data?.content?.length < 1 ||
      currencyData?.data?.data?.content?.length == undefined
    ) {
      filterCurrency(param);
    }
  }, []);

  const onSaveSuccess = useCallback(() => {
    setOpenAddModal(false);
    getData();
  }, [getData]);

  return (
    <>
      <div className="px-3 py-2">
        {/* Action Bar */}
        <div className="!mb-4">
          <div className="flex justify-end items-center gap-2">
            <Button
              variant="outline"
              size="icon"
              title="Sync"
              onClick={getData}
              className="bg-white hover:!bg-gray-200 p-0"
            >
              <RefreshCw className="size-4" />
            </Button>
            <Button
              title="Add Bank Charge"
              onClick={() => setOpenAddModal(true)}
              className="bg-red-600 hover:bg-red-700 text-white !px-3 !text-sm"
            >
              <Plus className="size-4 mr-2" />
              Add New
            </Button>
          </div>
        </div>

        <PaginationMainTable
          pageSize={bankChargesList?.length || 0}
          setPageSize={() => {}}
          hasNext={false}
          hasPrev={false}
          onNextPage={() => {}}
          onPreviousPage={() => {}}
          isLoadingPage={isLoadingPage}
          loadingLabel="Loading bank charges"
          onCancelLoading={listLoad.cancel}
          cancelled={listLoad.cancelled}
          pageNo={0}
          wrapperClassName="rounded-lg border border-gray-200 overflow-hidden"
        >
          <BankChargesTableComponent
            tableData={bankChargesList || []}
            isLoadingPage={isLoadingPage}
          />
        </PaginationMainTable>
      </div>

      {openAddModal && (
        <Modal
          className="addnewpopupRoutes"
          show={openAddModal}
          onHide={() => setOpenAddModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <h4 className="fontSize16 blackText fontWeight500">Add Bank Charges</h4>
          </Modal.Header>
          <Modal.Body>
            <BankChargesForm
              countriesData={countriesData}
              currencyData={currencyData}
              onSaveSuccess={onSaveSuccess}
              onCancel={() => setOpenAddModal(false)}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default BankCharges;
